import React from 'react';

const DataPolicy = () => {
  return (
    <div className="md:px-24 mx-auto px-4 text-black font-sans md:mb-20 mb-10">
      <h2 className="md:text-[36px] text-[14px] font-bold text-[#03897B] mb-4">DATA POLICY</h2>
      <p className="md:text-[24px] text-[10px] font-light mb-6">Website Data Policy</p>
      <p className="md:text-[24px] text-[10px] font-light text-black mb-8">Updated: 30th April 2025</p>

      <div className="md:space-y-7 space-y-5 font-light text-[10px] leading-relaxed md:text-[24px]">
        <section>
          <h3 className="md:-mb-2 mb-1">1. Purpose</h3>
          <p>
            This Data Protection Policy sets out how Ad-Luck Holdings, a company registered in South Africa, collects, processes, stores, and protects personal information in compliance with the Protection of Personal Information Act (POPIA), 2013.
            We are committed to safeguarding the privacy and security of personal information entrusted to us by users of our website: <a href="https://www.ad-luck.co.za" >www.ad-luck.co.za</a>.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">2. Scope</h3>
          <p>This policy applies to:</p>
          <ul className="list-disc list-inside md:-mt-2  mt-1  md:-space-y-2">
            <li>All employees, contractors, and third-party service providers of Ad-Luck Holdings</li>
            <li>All personal information processed via our website</li>
            <li>Any other platform or system used to collect user data</li>
          </ul>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">3. Definition of Personal Information</h3>
          <p>In accordance with POPIA, "personal information" includes any information that can identify a person, such as:</p>
          <ul className="list-disc list-inside md:-mt-2  mt-1  md:-space-y-2">
            <li>Full name, ID/passport number</li>
            <li>Email address, phone number</li>
            <li>Residential or business address</li>
            <li>IP address or device identifiers</li>
            <li>Payment or billing details</li>
            <li>Personal preferences, browsing habits, etc.</li>
          </ul>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">4. Data Collection Principles</h3>
          <p>We follow these core principles when processing personal information:</p>
          <ul className="list-disc list-inside md:-mt-2  mt-1  md:-space-y-2">
            <li>Lawfulness, fairness, and transparency</li>
            <li>Purpose limitation</li>
            <li>Data minimisation</li>
            <li>Accuracy</li>
            <li>Storage limitation</li>
            <li>Integrity and confidentiality</li>
            <li>Accountability</li>
          </ul>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">5. How We Collect Data</h3>
          <p>We may collect personal data through:</p>
          <ul className="list-disc list-inside md:-mt-2  mt-1 md:-space-y-2">
            <li>Website forms (e.g., contact, sign-up, checkout)</li>
            <li>Cookies and analytics tracking</li>
            <li>Email communications</li>
            <li>Orders or service requests</li>
          </ul>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">6. How We Use Personal Information</h3>
          <p>Personal information may be used to:</p>
          <ul className="list-disc list-inside md:-mt-2  mt-1  md:-space-y-2">
            <li>Provide and deliver services or products</li>
            <li>Communicate with users about services, offers, or changes</li>
            <li>Process payments and send invoices</li>
            <li>Monitor website performance and user engagement</li>
            <li>Comply with legal or regulatory requirements</li>
          </ul>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">7. Sharing of Personal Information</h3>
          <p>We may share your information with:</p>
          <ul className="list-disc list-inside md:-mt-2  mt-1  md:-space-y-2">
            <li>Third-party service providers who process data on our behalf (e.g. payment gateways, hosting providers)</li>
            <li>Government or legal entities when required by law</li>
          </ul>
          <p className="mt-2">No personal data will be sold or rented to third parties. All third-party processors are bound by confidentiality and data protection agreements.</p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">8. Data Security</h3>
          <p>We implement appropriate technical and organizational measures to secure personal data, including:</p>
          <ul className="list-disc list-inside md:-mt-2  mt-1  md:-space-y-2">
            <li>Secure hosting (SSL encryption)</li>
            <li>Role-based access controls</li>
            <li>Regular backups</li>
            <li>Antivirus and firewall systems</li>
            <li>Employee training in data protection</li>
          </ul>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">9. Data Subject Rights</h3>
          <p>Users have the following rights under POPIA:</p>
          <ul className="list-disc list-inside md:-mt-2  mt-1  md:-space-y-2">
            <li>Right of access – to request information about the data we hold</li>
            <li>Right to correction or deletion – of inaccurate or outdated data</li>
            <li>Right to object – to the processing of personal data</li>
            <li>Right to withdraw consent – at any time</li>
            <li>Right to complain – to the Information Regulator of South Africa</li>
          </ul>
          <p className="mt-2">
            To exercise your rights, contact us at:<br />
            📧 Email: info@ad-luck.co.za<br />
            📍 Address: Midstream, Centurion, Gauteng, South Africa
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">10. Data Retention</h3>
          <p>
            We retain personal information only for as long as necessary to fulfill the purposes it was collected for or to comply with legal, tax, or regulatory requirements.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">11. Breach Notification</h3>
          <p>
            In the event of a data breach, we will:
          </p>
          <ul className="list-disc list-inside md:-mt-2  mt-1  md:-space-y-2">
            <li>Notify the Information Regulator</li>
            <li>Inform affected data subjects where required</li>
            <li>Take immediate action to limit the impact and prevent recurrence</li>
          </ul>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">12. Policy Review</h3>
          <p>
            This policy will be reviewed annually or whenever significant changes to data processing activities occur.
          </p>
        </section>

        <section>
          <h3 className="md:-mb-2 mb-1">13. Contact Information</h3>
          <p>
            If you have any questions or concerns regarding this policy or how we handle personal information, please contact:<br />
            Data Protection Officer<br />
            📧 DPO@ad-luck.co.za<br />
            📞 +27 65 832 6460<br />
            📍 Midstream, Centurion, Gauteng, South Africa
          </p>
        </section>
        <section>
          <h3 className="md:-mb-2 mb-1">11. Contact Information</h3>
          <p>
            If you have any questions regarding this Privacy Policy, please contact us at:<br />
            📧 Email: Info@adluck.co.za<br />
            📍 Address: Midstream, Centurion, Gauteng, South Africa
          </p>
        </section>
      </div>
    </div>
  );
};

export default DataPolicy;
